export type NotificationStatus =
  | "SCHEDULED" // Programada
  | "ACTIVE" // Ativa
  | "EXPIRED" // Expirada
  | "DELETED"; // Excluída (soft delete)

export enum NotificationStatusEnum {
  SCHEDULED = "SCHEDULED",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  DELETED = "DELETED",
}
export const { SCHEDULED, ACTIVE, EXPIRED, DELETED } = NotificationStatusEnum;

export interface INotificationTarget {
  centers: string[]; // codigos de centro (ex.: ["C003"])
  segments: string[]; // ex.: ["Atem"]
  profiles: string[]; // ex.: ["Cliente", "Motorista", "Transportador"]
}

export interface INotification {
  id: string;
  refId: string;
  title: string;
  content: string;
  startAt: string;
  expireAt: string;
  profiles: string[];
  segments: string[];
  centers: string[];
  createdBy: string;
  createdAt: string;
  updatedAt?: string;
  imageUrl?: string | null;
  createdByName?: string;
  imageType?: string | null;
  deletedBy?: string | null;
  deletedByName?: string | null;
  deletedAt?: string | null;
}

export interface INotificationWithUser extends INotification {
  notificationUser: IUserNotification;
}

export interface INotificationWithUsers extends INotification {
  notificationUsers: IUserNotification[];
}

export interface IUserNotification {
  id: string;
  notificationId: string;
  userId: string;
  userName: string;
  userEmail: string;
  readAt: string | null;
  createdAt: string;
  updatedAt?: string;
  deletedAt?: string | null;
}

export interface IUserNotificationWithDetails extends IUserNotification {
  notification: INotification;
}

export interface INotificationFilter {
  id?: string;
  refId?: string;
  title?: string;
  periodStart?: string; // ISO
  periodEnd?: string; // ISO
  recipient?: string; // termo para centro/segmento/perfil
  centers?: string;
  profiles?: string;
  segments?: string;
  status?: NotificationStatus;
  includeRead?: boolean;
  page?: number;
  size?: number;
  retrieveUsers?: boolean;
}

export interface IPaginatedNotifications {
  rows: INotificationWithUsers[];
  count: number;
}

export interface INotificationRead {
  name: string;
  email: string;
  readAt: string;
}

export interface INotificationCreateDTO {
  title: string;
  content: string;
  centers: string[]; // codigos de centro (ex.: ["C003"])
  segments: string[]; // ex.: ["Atem"]
  profiles: string[]; // ex.: ["Cliente", "Motorista", "Transportador"]
  startAt: string;
  expireAt: string;
  fileKey?: string;
  fileType?: string;
}

export interface INotificationUpdateDTO extends INotificationCreateDTO {
  id: number;
}

export interface IUserContextForNotification {
  name: string;
  email: string;
  centers: string[];
  segments: string[];
  profiles: string[];
}

export interface INotificationUploadResponse {
  fileKey: string;
  fileType: string;
}

export interface ISegment {
  id: string;
  desc: string;
}

export interface ISegmentOption {
  value: string;
  label: string;
}

export interface ICenter {
  id: string;
  desc: string;
}

export interface ICenterOption {
  value: string;
  label: string;
}

export interface INotificationService {
  getNotificationsByUser(
    readStatus?: string
  ): Promise<IUserNotificationWithDetails[]>;
  searchNotifications(
    params: INotificationFilter
  ): Promise<IPaginatedNotifications>;
  uploadNotificationImage(file: File): Promise<INotificationUploadResponse>;
  createNotification(data: INotificationCreateDTO): Promise<INotification>;
  updateNotification(
    id: string,
    data: INotificationCreateDTO
  ): Promise<INotification>;
  deleteNotification(id: string): Promise<void>;
  getUserNotificationById(id: string): Promise<IUserNotificationWithDetails>;
  getNotificationById(id: string): Promise<INotification>;
  readNotification(id: string): Promise<INotificationRead[]>;
  unreadNotification(id: string): Promise<void>;
  getSegments(): Promise<ISegment[]>;
  getCenters(): Promise<ICenter[]>;
}
